// Author Lin
// Date 2024-06-05 16:34:40

class SithMesInventoryStockReturn {
    constructor({
                    id = null,
                    inspectStatus = '',
                    orderCode = '',
                    projectCode = '',
                    materialCode = '',
                    materialDescription = '',
                    materialLocation = '',
                    plant = '',
                    specialStockIndicator = '',
                    returnQuantity = '',
                    materialUnit = '',
                    movementType = '',
                    salesOrder = '',
                    salesOrderItem = '',
                    storageType = '',
                    storageBin = '',
                    returnOperator = '',
                    returnTime = '',
                    batchNumber = '',
                    wbsNumber = '',
                    occupiedCapacity = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.inspectStatus = inspectStatus;
        this.orderCode = orderCode;
        this.projectCode = projectCode;
        this.materialCode = materialCode;
        this.materialDescription = materialDescription;
        this.materialLocation = materialLocation;
        this.plant = plant;
        this.specialStockIndicator = specialStockIndicator;
        this.returnQuantity = returnQuantity;
        this.materialUnit = materialUnit;
        this.movementType = movementType;
        this.salesOrder = salesOrder;
        this.salesOrderItem = salesOrderItem;
        this.storageType = storageType;
        this.storageBin = storageBin;
        this.returnOperator = returnOperator;
        this.returnTime = returnTime;
        this.batchNumber = batchNumber;
        this.wbsNumber = wbsNumber;
        this.occupiedCapacity = occupiedCapacity;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesInventoryStockReturn();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectStatus',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.inspectStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '检验合格'},
                    {value: '2', text: '已提交检验'},
                    {value: '3', text: '未提交检验'},
                    {value: '4', text: '检验不合格'}
                ]
            }
        },
        {
            key: 'startTime',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.startTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspectTime',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.inspectTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inspector',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.inspector',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialLocation',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.materialLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.plant',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialStockIndicator',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.specialStockIndicator',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'returnQuantity',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.returnQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialUnit',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.materialUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'movementType',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.movementType',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.salesOrder',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrderItem',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.salesOrderItem',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageType',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.storageType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageBin',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.storageBin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'returnOperator',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.returnOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'returnTime',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.returnTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batchNumber',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.batchNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsNumber',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.wbsNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'occupiedCapacity',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.occupiedCapacity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryStockReturn.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    inspectStatusFilter: '',
    orderCodeFilter: '',
    projectCodeFilter: '',
    materialCodeFilter: '',
    materialDescriptionFilter: '',
    materialLocationFilter: '',
    plantFilter: '',
    specialStockIndicatorFilter: '',
    returnQuantityFilter: '',
    materialUnitFilter: '',
    movementTypeFilter: '',
    salesOrderFilter: '',
    salesOrderItemFilter: '',
    storageTypeFilter: '',
    storageBinFilter: '',
    storageBinIsNullFilter: '',
    createdByNameFilter: '',
    returnOperatorFilter: '',
    returnTimeRteFilter: '',
    returnTimeLteFilter: '',
    batchNumberFilter: '',
    wbsNumberFilter: '',
    occupiedCapacityFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'inspectStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.inspectStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialLocationFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.materialLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.salesOrder',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItemFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.salesOrderItem',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.storageType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageBinFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.storageBin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageBinIsNullFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.storageBinIsNull',
        disabled: false,
        form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnOperatorFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.returnOperator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.returnTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.filter.returnTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'inspectStatus',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.inspectStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '检验合格'},
                {value: '2', text: '已提交检验'},
                {value: '3', text: '未提交检验'},
                {value: '4', text: '检验不合格'}
            ]
        }
    },
    {
        key: 'orderCode',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.orderCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescription',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.materialDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialLocation',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.materialLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockIndicator',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.specialStockIndicator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnQuantity',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.returnQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialUnit',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.materialUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'movementType',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.movementType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrder',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.salesOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'salesOrderItem',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.salesOrderItem',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageBin',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.storageBin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnOperator',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.returnOperator',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'returnTime',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.returnTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchNumber',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.batchNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsNumber',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.wbsNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'occupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.occupiedCapacity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryStockReturn.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryStockReturn, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
